
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm, { MiezzFormItem } from "@/models/MiezzForm";
import CompanyFollowUpRecordAppService from "@/apis.machine/CompanyFollowUpRecordAppService";
import DtoFormCompanyFollowUpRecord, {
  DtoFormCompanyFollowUpRecordMiezzFormItems,
  DtoFormCompanyFollowUpRecordRules,
} from "@/models.machine/DtoFormCompanyFollowUpRecord";
import DtoSelectOptionCompany from "@/models.machine/DtoSelectOptionCompany";
import CompanyAppService from "@/apis.machine/CompanyAppService";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import MiezzInput from "@/components/MiezzInput.vue";
import UiSelectOption from "@/models.machine/UiSelectOption";
import JoinCompanyUserAppService from "@/apis.machine/JoinCompanyUserAppService";
import ParamCountryAreaAppService from "@/apis.machine/ParamCountryAreaAppService";
import {
  EnumCompanyFollowUpRecordStatus,
  EnumCompanyFollowUpRecordStatusOption,
} from "@/models.machine/EnumCompanyFollowUpRecordStatus";
import CurrentLogier from "@/apis/CurrentLogier";

export default class CompanyFollowUpRecordForm extends Vue {
  @Prop() type?: EnumCompanyType;
  @Prop() form!: MiezzForm<DtoFormCompanyFollowUpRecord, string>;

  id?: string;

  buttons: MiezzButton[] = [
    {
      Code: "back",
      Label: "返回",
      MiezzIcon: "back",
      Type: "text",
      Size: "small",
    },
    {
      Code: "submit",
      Label: "保存",
      Icon: "select",
      Type: "text",
      Size: "small",
    },
  ];
  methods: UiSelectOption<string>[] = [];
  contents: UiSelectOption<string>[] = [];
  users: UiSelectOption<string>[] = [];
  companies: DtoSelectOptionCompany[] = [];
  EnumCompanyFollowUpRecordStatusOption = EnumCompanyFollowUpRecordStatusOption;

  created(): void {
    this.id = this.$route.params.id as string;
    this.form.DefaultSpan = 12;
    //表单-数据-初始化
    this.form.Data = new DtoFormCompanyFollowUpRecord();
    //表单-校验
    this.form.Rules = DtoFormCompanyFollowUpRecordRules;
    this.form.Rules.PlanFollowUpTime = [
      {
        required: true,
        validator: (rule: any, value: Date, callback: any) => {
          if (!this.form.Data.PlanFollowUpTime) {
            return callback(new Error("信息不能为空"));
          } else {
            if (
              this.form.Data.PlanCompleteTime &&
              this.form.Data.PlanFollowUpTime > this.form.Data.PlanCompleteTime
            ) {
              return callback(
                new Error("计划跟进时间不能晚于计划完成时间，请重新填写")
              );
            } else if (this.form.Data.CustomerLabel) {
              CompanyFollowUpRecordAppService.CheckExist(
                this.id,
                this.type,
                this.form.Data.CustomerLabel,
                this.form.Data.PlanFollowUpTime
              ).then((r) => {
                if (r.data.Data) {
                  return callback(
                    new Error("同一天不能有两个跟进记录，请重新填写")
                  );
                } else {
                  callback();
                }
              });
            } else {
              callback();
            }
          }
        },
        trigger: "change",
      },
    ];
    this.form.Rules.Status = [
      {
        validator: (rule: any, value: number, callback: any) => {
          if (!this.form.Data.Status) {
            return callback(new Error("信息不能为空"));
          }
          callback();
        },
        trigger: "change",
      },
    ];
    this.form.Rules.CustomerLabel = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "blur",
      },
      {
        validator: (rule: any, value: string, callback: any) => {
          setTimeout(() => {
            if (this.form.Data.CustomerLabel && !this.form.Data.CustomerId) {
              if (
                this.companies.any(
                  (it) =>
                    it.Name == this.form.Data.CustomerLabel ||
                    it.NameZh == this.form.Data.CustomerLabel ||
                    it.NameEn == this.form.Data.CustomerLabel
                )
              ) {
                return callback(
                  new Error(
                    `该信息与${
                      this.type == EnumCompanyType.Customer ? "客户" : "供应商"
                    }管理中的信息重复，请通过选择录入信息`
                  )
                );
              } else {
                ElMessage.warning(
                  `该${
                    this.type == EnumCompanyType.Customer ? "客户" : "供应商"
                  }信息未在${
                    this.type == EnumCompanyType.Customer ? "客户" : "供应商"
                  }管理中添加`
                );
              }
            }
            callback();
          }, 100);
        },
        trigger: "blur",
      },
    ];
    //表单-元素配置
    this.initFormItems(DtoFormCompanyFollowUpRecordMiezzFormItems.copy());

    CompanyAppService.GetSelect({ CompanyType: this.type }).then((r) => {
      this.companies = r.data.Data ?? [];
    });
    JoinCompanyUserAppService.GetSelect().then((r) => {
      this.users = r.data.Data ?? [];
    });
    CompanyFollowUpRecordAppService.GetHistory(this.type, "Method").then(
      (r) => {
        this.methods = r.data.Data ?? [];
      }
    );
    CompanyFollowUpRecordAppService.GetHistory(this.type, "Content").then(
      (r) => {
        this.contents = r.data.Data ?? [];
      }
    );
    this.handleGet();
  }

  initFormItems(items: MiezzFormItem[]): void {
    //修改元素配置
    for (const item of items) {
      switch (item.Prop) {
        case "CustomerLabel":
          item.Label =
            this.type == EnumCompanyType.Customer ? "客户企业" : "供应商企业";
          break;
        default:
          break;
      }
    }
    this.form.Items = items;
  }

  /**查询表单数据 */
  handleGet(): void {
    if (this.id) {
      CompanyFollowUpRecordAppService.GetById(this.id).then((r) => {
        if (r.data.Data) this.form.Data = r.data.Data;
        this.onStatusChanged();
      });
    } else {
      this.form.Data.CustomerId = this.$route.query.CustomerId as string;
      this.form.Data.CustomerLabel = this.$route.query.CustomerLabel as string;
      this.form.Data.FollowUpPersonId = this.$route.query
        .FollowUpPersonId as string;
      this.form.Data.FollowUpPersonLabel = this.$route.query
        .FollowUpPersonLabel as string;
      this.form.Data.Status = EnumCompanyFollowUpRecordStatus.WaitExec;
      this.onStatusChanged();
    }
  }

  handleDeleteLink(name: string, value: string): void {
    CompanyFollowUpRecordAppService.DeleteHistory(this.type, name, value).then(
      () => {
        if (name == "Method") {
          if (this.form.Data.Methods?.any((it) => it.Method == value)) {
            this.form.Data.Methods?.remove((it) => it.Method == value);
          }
          CompanyFollowUpRecordAppService.GetHistory(this.type, "Method").then(
            (r) => {
              this.methods = r.data.Data ?? [];
            }
          );
        } else {
          if (this.form.Data.Contents?.any((it) => it.Content == value)) {
            this.form.Data.Contents?.remove((it) => it.Content == value);
          }
          CompanyFollowUpRecordAppService.GetHistory(this.type, "Content").then(
            (r) => {
              this.contents = r.data.Data ?? [];
            }
          );
        }
      }
    );
  }

  @Watch("form.Data.Methods")
  onMethodsChanged(): void {
    if (
      this.form.Data.Methods?.any(
        (it) => it.Method == "现场拜访" || it.Method == "网络/电话会议"
      )
    ) {
      const items = DtoFormCompanyFollowUpRecordMiezzFormItems.copy();
      this.initFormItems(items);
    } else {
      const items = DtoFormCompanyFollowUpRecordMiezzFormItems.filter(
        (it) =>
          it.Prop != "AreaLabel" &&
          it.Prop != "Address" &&
          it.Prop != "CustomerJoinPerson" &&
          it.Prop != "InnerAccompanyPeople" &&
          it.Prop != "OuterAccompanyPerson" &&
          it.Prop != "ThreeJoinPerson"
      );
      this.initFormItems(items);
      this.form.Data.AreaLabel = undefined;
      this.form.Data.Address = undefined;
      this.form.Data.CustomerJoinPerson = undefined;
      this.form.Data.InnerAccompanyPeople = undefined;
      this.form.Data.OuterAccompanyPerson = undefined;
      this.form.Data.ThreeJoinPerson = undefined;
    }
  }

  @Watch("form.Data.PlanCompleteTime")
  onPlanCompleteTimeChanged(): void {
    if (this.form.Data.PlanCompleteTime) {
      this.form.Data.Status = EnumCompanyFollowUpRecordStatus.Completed;
    }
  }

  @Watch("form.Data.Status")
  onStatusChanged(): void {
    this.form.Rules.PlanCompleteTime = [
      {
        required:
          this.form.Data.Status == EnumCompanyFollowUpRecordStatus.Completed,
        validator: (rule: any, value: Date, callback: any) => {
          if (value) {
            if (this.form.Data.PlanFollowUpTime) {
              if (value < this.form.Data.PlanFollowUpTime) {
                return new Error(
                  "计划跟进时间不能晚于计划完成时间，请重新填写"
                );
              } else {
                MiezzForm.validateField(
                  this.$refs,
                  "ruleForm",
                  "PlanFollowUpTime"
                );
              }
            }
          } else if (
            this.form.Data.Status == EnumCompanyFollowUpRecordStatus.Completed
          ) {
            return new Error("信息不能为空");
          }
          callback();
        },
        trigger: "change",
      },
    ];
  }

  getCompanies(q: string, cb: any): void {
    if (q) {
      cb(this.companies.filter((it) => it.Name?.contains(q)));
    } else {
      cb(this.companies);
    }
  }

  handleSelectCompany(item?: DtoSelectOptionCompany): void {
    if (item && item.Id && item.Name == this.form.Data.CustomerLabel) {
      this.form.Data.CustomerId = item.Id;
    } else {
      this.form.Data.CustomerId = undefined;
    }
    (
      (this.$refs["ref-company-label"] as MiezzInput).$refs[
        "ref-miezz-input"
      ] as any
    ).blur();
  }

  /**提货地址与时间-获取坐标 */
  getAreas(q: string, cb: any): void {
    if (q && q.length >= 2) {
      ParamCountryAreaAppService.GetSelect({
        Keywords: q,
      }).then((r) => {
        cb(r.data.Data ?? []);
      });
    } else {
      cb([]);
    }
  }
  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "submit":
        MiezzForm.submit(this.$refs, "ruleForm", (v) => {
          if (v) {
            this.form.Data.CompanyType = this.type;
            for (const person of this.form.Data.InnerAccompanyPeople ?? []) {
              person.InnerAccompanyPersonLabel =
                this.users.firstOrDefault(
                  (it) => it.Value == person.InnerAccompanyPersonId
                )?.Label ?? person.InnerAccompanyPersonLabel;
            }
            CompanyFollowUpRecordAppService.Post(this.form.Data)
              .then(() => {
                ElMessage.success("操作成功");
                CurrentLogier.Back();
                complete();
              })
              .catch(complete);
          } else complete();
        });
        break;
      default:
        break;
    }
  }
}
